export default {
  domain: window.location.origin,
  timeout: 3600 * 1000,   
  authTimeout: 2 * 60 * 60 * 1000,
  //是否是生成环境,true 代表是   false:代表否
  isProd:true
};
